import { NgModule } from "@angular/core";
import { CommonModule } from "common";
import { RouterModule } from "@angular/router";
import { AppBarDropdownComponent } from "./app-bar-dropdown/app-bar-dropdown.component";
import { DashboardComponent } from "@uppy/angular";
import { SubmissionStatusComponent } from "./submission-status/submission-status.component";
import { UploadFileDialogImprovedComponent } from "./upload-file-dialog-improved/upload-file-dialog-improved.component";
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { AdvisorWidgetComponent } from "./advisor-widget/advisor-widget.component";
import { AdvisorWidgetButtonComponent } from "./advisor-widget-button/advisor-widget-button.component";

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    DashboardComponent,
    NgxSkeletonLoaderModule
  ],
  exports: [
    CommonModule,
    AppBarDropdownComponent,
    SubmissionStatusComponent,
    NgxSkeletonLoaderModule,
    AdvisorWidgetComponent,
    AdvisorWidgetButtonComponent
  ],
  declarations: [
    UploadFileDialogImprovedComponent,
    AppBarDropdownComponent,
    SubmissionStatusComponent,
    AdvisorWidgetComponent,
    AdvisorWidgetButtonComponent
  ],
})
export class SharedModule {}
